import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-roles-description',
  templateUrl: './roles-description.component.html'
})
export class RolesDescriptionComponent {
  @Input() userProfile: any;
}
